import { graphql } from "relay-runtime"

export const GynaecologyFragment = graphql`
  fragment GynaecologyFragment on Gynaecology {
    firstPeriod
    id
    menopauseSince
    patientId
    pregnancy
    pregnancyHistory
    weeksOfPregnancy
  }
`
